import I18n from 'app/i18n';
import Post from 'app/utils/Post';
import {modalConfirm} from 'app/utils/modals/popups';
import {userStore} from 'app/store/global';
import {REGISTRATION_PROMO_OPTIN_KEY} from 'app/utils/Consts';

const optInToMarketing = (): void => {
    new Post({
        url: '/user/marketing_consent'
    })
        .execute()
        .then((response: Response) => {
            if (response.ok) {
                userStore.update({user: {...userStore.user, marketing_consent: true}});
            }
        })
        .catch(() => null);
};

export const markRegistrationPromoOptInNeeded = (): void => {
    window.sessionStorage.setItem(REGISTRATION_PROMO_OPTIN_KEY, '1');
};

export const showRegistrationPromoOptInPopup = (): void => {
    const pending = window.sessionStorage.getItem(REGISTRATION_PROMO_OPTIN_KEY);

    if (!pending || !userStore.user.user_id || userStore.user.marketing_consent) {
        window.sessionStorage.removeItem(REGISTRATION_PROMO_OPTIN_KEY);
        return;
    }

    window.sessionStorage.removeItem(REGISTRATION_PROMO_OPTIN_KEY);
    modalConfirm(
        I18n.t('registration_promo_optin_text'),
        optInToMarketing,
        null,
        {
            cancelText: I18n.t('registration_promo_optin_decline'),
            classNameModal: 'popup__content--promo-optin',
            hideCloseButton: true,
            okText: I18n.t('registration_promo_optin_button')
        }
    );
};
